// @flow
import React from 'react';
import {Input} from 'reactstrap'
import AbstractField from "./AbstractField";
import {COMPONENT_CHILDREN} from './../Utils2';

/**
 * Field pro editaci dokladu.
 */
class SubjektDokladField extends AbstractField {

    static PropTypes = {
        // Typ dokladu, konstanta z EnumTypDoklad
        typDoklad: React.PropTypes.string.isRequired,
        // Objekt typu SubjektDokladRO
        value: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]), // string musí být, protože při prázdném poli dává redux prázdný string, místo objektu!
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    getInputValue = (value) => {
        return value ? (value.dokladCislo ? value.dokladCislo : "") : "";
    };

    getObjValue = (e) => {
        const {value, typDoklad} = this.props;

        let objValue;
        if (value) {
            objValue = {
                typDoklad: typDoklad,        // případně bude překryt v ...value
                ...value,
                dokladCislo: e.target.value,
            }
        } else {
            objValue = {
                typDoklad: typDoklad,
                dokladCislo: e.target.value,
            }
        }

        return objValue;
    };

    handleOnChange = (e) => {
        const {onChange} = this.props;
        onChange(this.getObjValue(e));
    };

    handleBlur = (e) => {
        const {onBlur} = this.props;
        onBlur(this.getObjValue(e));
    };

    render() {
        const {addonsBefore, addonsAfter, onChange, onBlur, typDoklad, value, ...props} = this.props;

        const field = <Input
            type="text"
            onChange={this.handleOnChange}
            onBlur={this.handleBlur}
            value={this.getInputValue(value)}
            {...props}
        />;

        return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    }
}

export default SubjektDokladField;
